import React, { useState } from "react";
import { ChevronDown } from "lucide-react";

export function RevealList({ label, items, id }: { label?: string; items?: string; id: string }) {
  const [open, setOpen] = useState(false);
  const list = (items || "").split("\n").map((s) => s.replace(/^\s*[-•*]\s*/, "").trim()).filter(Boolean);
  if (!list.length) return null;
  return (
    <div className="mt-4" data-testid={`reveal-${id}`}>
      <button type="button" onClick={() => setOpen(!open)} aria-expanded={open} aria-controls={`reveal-list-${id}`}
        className="inline-flex items-center gap-2 eyebrow border-b border-current pb-1 hover:text-[var(--c-primary)] transition-colors" data-testid={`reveal-toggle-${id}`}>
        {open ? "Hide" : label || "View list"}
        <ChevronDown size={14} strokeWidth={1.5} className={`transition-transform duration-300 ${open ? "rotate-180" : ""}`} />
      </button>
      <div className={`grid transition-[grid-template-rows,opacity] duration-500 ease-out ${open ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"}`} aria-hidden={!open}>
        <ul id={`reveal-list-${id}`} className="overflow-hidden list-disc pl-5 space-y-2 text-sm md:text-[15px]" data-testid={`reveal-list-${id}`}>
          {list.map((t, i) => <li key={i} className={i === 0 ? "mt-5" : ""}>{t}</li>)}
        </ul>
      </div>
    </div>
  );
}
